import React from "react";
import { Typography, Button, makeStyles } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  button: {
    height: theme.spacing(7),
    background: "#fff",
    border: "1px solid #A6AEBF",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0, 3),
    margin: theme.spacing(0, 1),
    whiteSpace: "nowrap",
    "&:hover": {
      background: "#fff",
    },
    "& img": {
      filter: "brightness(100) invert(0)",
      marginRight: 20,
    },
    "& .MuiTypography-root": {
      fontSize: theme.spacing(2),
      color: "#003366!important",
      fontWeight: 700,
      textTransform: "none",
    },
  },
}));

const DefaultButton = props => {
  const { onClick, title, icon, appendIcon = false, className, children, ...rest} = props;
  const classes = useStyles();

  return (
    <Button onClick={onClick} className={clsx(classes.button, className)} {...rest}>
      {children && children}
      {!children &&
        <>
          {!appendIcon && icon && <img src={icon} alt=":( Not Found" />}
          <Typography>{title}</Typography>
          {appendIcon && icon && <img src={icon} alt=":( Not Found" />}
        </>
      }
    </Button>
  );
};

export default DefaultButton;
